import React, { useState } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ContractForm from "../contractForm/ContractForm";

const AddContractButton = ({ refreshContracts }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Add Contract
      </Button>
      <ContractForm
        open={open}
        handleClose={handleClose}
        refreshContracts={refreshContracts}
      />
    </>
  );
};

export default AddContractButton;